console.info("Hey its js");

// (function () {
//   const header = document.querySelector(".header");
//   // set body’s top padding to exactly the header’s rendered height
//   function adjustPadding() {
//     document.body.style.paddingTop = header.offsetHeight + "px";
//   }
//   window.addEventListener("resize", adjustPadding);
//   adjustPadding();
// })();



 document.addEventListener('DOMContentLoaded', () => {

 

    const menu       = document.getElementById('MobileMenu');
    const openBtn    = document.querySelector('.header__hamburger'); // your hamburger selector
    const closeBtn   = menu.querySelector('.mobile-menu__close');
    const pageOverlay = document.createElement('div');

    // Create an overlay to catch outside clicks
    pageOverlay.id = 'MobileMenuOverlay';
    pageOverlay.style = `
      position: fixed;
      top: 0; left: 0;
      width: 100vw; height: 100vh;
      background: rgba(0,0,0,0.4);
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 1400;
      pointer-events: none;
    `;
    document.body.appendChild(pageOverlay);

    function openMenu() {
      menu.classList.add('open');
      pageOverlay.style.opacity = '1';
      pageOverlay.style.pointerEvents = 'auto';
      document.body.style.overflow = 'hidden'; // prevent body scroll
    }

    function closeMenu() {
      menu.classList.remove('open');
      pageOverlay.style.opacity = '0';
      pageOverlay.style.pointerEvents = 'none';
      document.body.style.overflow = ''; // restore scroll
    }

    openBtn.addEventListener('click', openMenu);
    closeBtn.addEventListener('click', closeMenu);

    // click on overlay closes menu
    pageOverlay.addEventListener('click', closeMenu);

    // close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.classList.contains('open')) {
        closeMenu();
      }




    });



    console.info("gsap is there")
     
 gsap.registerPlugin(ScrollTrigger);

    console.info("gsap is here")


  //2) create the pin
  
  ScrollTrigger.create({
    trigger: ".header__navigation",    // your header selector
    start:    "top top",        // when the top of header hits the top of the viewport...
    end:      "+=90000",        // effectively infinite
    pin:      true,             // pin it
    pinSpacing: false,          // remove extra padding
  });












  console.info("toggleBtn");

const toggleBtn = document.getElementById("search_func");
const overlay = document.querySelector(".search-overlay");
const input = document.getElementById("desktop-search-input");
const resultsContainer = document.querySelector(".search-results");


let isOpen = false;

toggleBtn.addEventListener("click", () => {
  console.info("toggleBtn", toggleBtn);

  if (!isOpen) {
    // Show with GSAP
    gsap.to(overlay, {
      opacity: 1,
      display: "flex",
      duration: 0.3,
      ease: "power2.out",
    });
    input.focus();
    isOpen = true;
  } else {
    // Hide with GSAP
    gsap.to(overlay, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        gsap.set(overlay, { display: "none" });
      },
    });
    isOpen = false;
  }
});

// Fetch search results as user types
let debounceTimeout;
input.addEventListener("input", () => {
  const query = input.value.trim();

  console.log("Search Triggered");

  clearTimeout(debounceTimeout);

  if (query.length < 2) {
    resultsContainer.innerHTML = "";
    return;
  }

  debounceTimeout = setTimeout(() => {
    fetch(
      `/search/suggest.json?q=${encodeURIComponent(
        query
      )}&resources[type]=product`
    )
      .then((res) => res.json())
      .then((data) => {
        const products = data.resources.results.products;

        if (products.length) {
          resultsContainer.innerHTML = products
            .map(
              (p) => `
                <div class="search-item">
                  <a class="search_itm_container" href="${p.url}">
                    <img class="search_image" src="${p.featured_image.url}" alt="${p.title}" width="40" height="40">
                    <div class="whole_desc_wrapper">
                    <span class="search_title">${p.title}</span>
                    <div class="price_btn_wrapper">
                    <span class="search_desc">${p.price}</span>
                    <button class="search_result_btn">View Now</button>
                    </div>
                    </div>
                  </a>
                </div>
              `
            )
            .join("");
        } else {
          resultsContainer.innerHTML = `<p class="sorry">No products found.</p>`;
        }
      });
  }, 300); // debounce
});


























  });





    